
export default function initCatalogFilter() {
    const filterOpen = document.querySelectorAll(".js-filter-open")
    const filterClose = document.querySelector(".js-filter-close")
    const filterCloseSecond = document.querySelector(".js-filter-close-second")
    const filter = document.querySelector(".catalog__filter")
    


    if (!filterOpen) return
    
    filterOpen.forEach((btn) =>{
        btn.addEventListener("click", () => {
            // значение скролла при нажатии на Фильтр
            let scroll = window.pageYOffset
            closeFilter(scroll)

            filter.classList.add("open")
            window.scroll({
                top: 0, 
                behavior: 'instant'
            })
            document.body.classList.add("filter-opened")
        })
    })
    

    function closeFilter (scroll){

        filter.addEventListener("mousedown", (e) => {
            if (e.target.classList.contains("popup") || e.target.classList.contains("js-filter-close") || e.target.classList.contains("js-filter-close-second")) {
                filter.classList.remove("open")
                document.body.classList.remove("filter-opened")
                // возвращает страницу к тому же скроллу, до нажатия кнопки Фильтра
                window.scroll({
                    top: scroll, 
                    behavior: 'instant'
                })
            }
        })
    }



}



// WEBPACK FOOTER //
// ./src/js/new-design/catalogFilter.js